module.exports = __webpack_public_path__ + "img/few_alley.28bb6157.png";